import React, {
	useCallback,
	useEffect,
	useRef,
	useState,
	useMemo,
} from "react";
import classes from "./index.module.css";
import PaginationTable from "../../components/Pagination";
import { AgGridReact } from "ag-grid-react";
import { ReactComponent as ExportIcon } from "../../assets/arrow-download-small.svg";
import { ReactComponent as SearchIcon } from "../../assets/search-find.svg";
import { ReactComponent as RejectIcon } from "../../assets/minus-remove-circle.svg";
import { ReactComponent as AcceptIcon } from "../../assets/check-circle.svg";
import DefaultInput from "../../components/form/DefaultInput";
import { Button, Divider, Image, Modal, Select, message } from "antd";
import { ColDef } from "ag-grid-community";
import { toast } from "react-toastify";
import { exportDataToCsv } from "../../utils/exportDataToCsv";
import api from "../../utils/axios";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import DefaultSelect from "../../components/form/DefaultSelect";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import { userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import { useMediaQuery } from "@mui/material";
import { CONFIG } from "../../config";

const UnapprovedAccounts = () => {
	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [tableData, setTableData] = useState([]);
	const [code, setCode] = useState<number>();
	const [firstName, setFirstName] = useState<string | undefined>();
	const [lastName, setLastName] = useState<string | undefined>();
	const [email, setEmail] = useState<string>("");
	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [businessNumber, setBusinessNumber] = useState<string>("");
	const [businessPhoneNumber, setBusinessPhoneNumber] = useState<string>("");
	const [businessName, setBusinessName] = useState<string>("");
	const [address, setAddress] = useState<string>("");
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryLabel, setCountryLabel] = useState<string | undefined>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [openModal, setOpenModal] = useState<boolean>();
	const [userRoleId, setUserRoleId] = useState<number>();
	const [cash, setCash] = useState<boolean>(true);
	const [bank, setBank] = useState<boolean>(false);
	const [vat, setVat] = useState<boolean>(false);
	const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
	const [openRejectModal, setOpenRejectModal] = useState<boolean>(false);
	const [imageUrls, setImageUrls] = useState<[]>([]);
	const { strings } = useLang("unapprovedAccounts");
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);

	let grid = useRef(null);

	const nameAndSurnameGetter = (params: any) => {
		const text = params.data.firstName + " " + params.data.lastName;
		return text;
	};
	const fetchPendingApprovals = useCallback(async () => {
		try {
			const response = await api.get("User/fetch-pending-aprovals");
			if (response.status === 200) {
				setTableData(response?.data);
			}
		} catch (error: any) {
			console.log(error.response.data);
		}
	}, []);

	const onDelete = async () => {
		try {
			const response = await api.delete(
				"User/reject-user-registration-request",
				{ params: { userId: clientId } }
			);
			if (response.status === 200) {
				setOpenRejectModal(false);
				await fetchPendingApprovals();
				toast.success("Aplikimi u fshi me sukses");
				return;
			}
		} catch (error: any) {
			console.error(error.response.data);
		}
	};

	const onAccept = async () => {
		try {
			const response = await api.post(
				"User/confirm-user-registration-request",
				null,
				{ params: { userId: clientId } }
			);
			if (response.status === 200) {
				setOpenConfirmModal(false);
				toast.success("Aplikimi u konfirmua me sukses");
				await fetchPendingApprovals();
				return;
			}
		} catch (error: any) {
			console.error(error.response.data);
		}
	};
	const onCountrySelect = (e: any) => {
		setCity("");
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCountry(e);
	};
	const onCitySelect = (e: any) => {
		setCity(e);
	};

	const isSmallScreen = useMediaQuery("(max-width: 994px)");

	useEffect(() => {
		fetchPendingApprovals();
		setTableColumns([
			{
				field: "id",
				headerName: strings?.code,
				cellStyle: (params: any) => ({
					fontSize: "15px",
					color: "blue",
				}),
				width: 80,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "firstName",
				valueGetter: nameAndSurnameGetter,
				headerName: strings?.nameSurname,
				width: 170,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "username",
				headerName: strings?.username,
				width: 120,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "address",
				headerName: strings?.address,
				width: 170,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "userRoleDescription",
				headerName: strings?.role,
				width: 100,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "phone",
				headerName: strings?.phone,
				width: 140,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "createdAt",
				headerName: strings?.createdAt,
				width: 150,
				suppressSizeToFit: isSmallScreen,
			},
			{
				width: 240,
				cellRenderer: (params: any) => {
					return (
						<>
							<div className={classes.buttonsAgGrid}>
								<Button
									onClick={() =>
										clickOpenRejectModal(params?.data)
									}
									className={classes.tableButtonFirst}
								>
									<RejectIcon />
									{strings?.reject}
								</Button>
								<Button
									// onClick={() => onAccept(params.data.id)}
									onClick={() =>
										clickOpenConfirmModal(params.data)
									}
									className={classes.tableButtonSecond}
								>
									<AcceptIcon />
									{strings?.accept}
								</Button>
							</div>
						</>
					);
				},
				suppressSizeToFit: isSmallScreen,
			},
		]);
	}, [fetchPendingApprovals, setTableColumns, strings]);

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const totalItems = tableData.length;

	const startOrderIndex = (currentPage - 1) * pageSize + 1;
	const endOrderIndex = Math.min(currentPage * pageSize, totalItems);

	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};
	const handlePageSizeChange = (current: number, size: number) => {
		setPageSize(size);
		setCurrentPage(1);
	};

	const onBtExport = useCallback(() => {
		if (grid) {
			(grid.current as any).api.exportDataAsExcel();
		}
	}, []);

	const filteredData = useMemo(() => {
		return tableData.filter((item: any) => {
			return !code || item.id.toString().includes(code);
		});
	}, [code, tableData]);

	const selectedColumnIds = [
		"id",
		"firstName",
		"username",
		"address",
		"userRoleDescription",
		"bussinesName",
		"createdAt",
	];

	const onExportSelectedId = () => {
		const dataToExport = filteredData.map((item: any) => ({
			firstName: `${item.firstName} ${item.lastName}`,
			...item,
		}));
		exportDataToCsv(grid, selectedColumnIds, dataToExport);
	};

	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);

	const [error, setError] = useState<boolean>(false);

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Passwords do not match");
			setError(true);
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);
	const [clientId, setClientId] = useState<any>();
	const [clientDetails, setClientDetails] = useState<any>([]);

	const setInput = (data: any) => {
		setClientDetails(data);
		setFirstName(data.firstName);
		setLastName(data.lastName);
		setIdentificationNumber(data.identificationNumber);
		setEmail(data.email);
		setUsername(data.username);
		setPhone(data.phone);
		setCountry(data.country);
		setCity(data.city);
		setAddress(data.address);
		setUserRoleId(data.userRoleId);
		setBusinessName(data.businessName);
		setBusinessPhoneNumber(data.businessNr);
		setBusinessNumber(data.businessNumber);
		setCash(data.cashPackageTransportPayment);
		setBank(data.bankPackageTransportPayment);
		setClientId(data.id);
		const businessImage = data?.businessLicenceFileName;
		const images = data?.identificationFileNames?.split(";") ?? [];
		const scrWithImages = images?.map(
			(image: any) =>
				`${CONFIG?.BASE_URL}/RegisteredClientImages/${image}`
		);
		const businessImagesSrc = `${CONFIG?.BASE_URL}/RegisteredBusinessImages/${businessImage}`;
		scrWithImages.push(businessImagesSrc);
		setImageUrls(scrWithImages);
	};

	const openEditModal = (rowData: any) => {
		const data = rowData?.data;
		setInput(data);
		setOpenModal(true);
	};
	const clickOpenConfirmModal = (rowData: any) => {
		const data = rowData;
		setFirstName(data?.firstName);
		setLastName(data?.lastName);
		setClientId(data?.id);
		setOpenConfirmModal(true);
	};
	const clickOpenRejectModal = (rowData: any) => {
		const data = rowData;
		setFirstName(data?.firstName);
		setLastName(data?.lastName);
		setClientId(data?.id);
		setOpenRejectModal(true);
	};

	const validateUpdatedData = (data: any) => {
		if (!data?.firstName) {
			toast.error("Emri është i detyrueshëm");
			return false;
		}
		if (!data?.lastName) {
			toast.error("Mbiemri është i detyrueshëm");
			return false;
		}
		if (!data?.phone) {
			toast.error("Numri i telefonit është i detyrueshëm");
			return false;
		}
		if (!data?.address) {
			toast.error("Adresa është e detyrueshme");
			return false;
		}
		if (!data?.username) {
			toast.error("Username është i detyrueshëm");
			return false;
		}
		// if (!data?.businessName) {
		// 	toast.error("Emri i biznesit eshte i detyrueshem");
		// 	return false;
		// }
		// if (!data?.businessPhoneNumberPrefix) {
		// 	toast.error("Numri Tel i biznesit eshte i detyrueshem");
		// 	return false;
		// }
		// if (!data?.businessNr) {
		// 	toast.error("Numri Tel i biznesit eshte i detyrueshem");
		// 	return false;
		// }
		if (
			clientDetails?.businessName?.length > 0 &&
			(!data.businessName || data.businessName.trim().length <= 0)
		) {
			toast.error("Emri i biznesit eshte i detyrueshem");
			return false;
		}
		if (
			clientDetails?.businessName?.length > 0 &&
			(!data.businessNumber || data.businessNumber.trim().length === 0)
		) {
			toast.error("Numri i biznesit eshte i detyrueshem");
			return false;
		}
		if (!data?.identificationNumber) {
			toast.error("Nr.Leternjoftimit është i detyrueshëm.");
			return false;
		} else {
			return true;
		}
	};

	const cleanStateOnClose = () => {
		setFirstName("");
		setLastName("");
		setPhone("");
		setAddress("");
		setUsername("");
		setPassword("");
		setConfirmPassword("");
		setUserRoleId(0);
		setIdentificationNumber("");
		setEmail("");
		setCountry("");
		setCity("");
		setOpenModal(false);
	};

	const saveUnconfirmedUserDetails = async () => {
		const data = {
			id: clientId,
			firstName: firstName,
			lastName: lastName,
			email: email ? email : null,
			phone: phone,
			username: username,
			address: address,
			businessName: businessName,
			businessNr: businessPhoneNumber,
			businessNumber: businessNumber,
			identificationNumber: identificationNumber,
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			// password: password,
		};

		// const validation = usernamePasswordValidate(username, password);

		if (validateUpdatedData(data)) {
			try {
				const response = await api.post("User/update", data);
				if (response.status === 200) {
					cleanStateOnClose();
					await fetchPendingApprovals();
					toast.success("Ndryshimet u ruajten me sukses");
					return;
				} else {
					toast.error(
						"Një gabim ndodhi gjatë krijimit. Ju lutemi provoni përsëri më vonë"
					);
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			return;
		}
	};

	const changeSwitch = () => {
		setCash((prevState) => !prevState);
		setBank((prevState) => !prevState);
	};

	return (
		<>
			<div className={classes.mainContainer}>
				{/* <FinanceStatistic /> */}

				<div className={classes.heroContainer}>
					<div className={classes.firstContainer}>
						<h1 className={classes.title}>
							{strings?.newAccountsApprovalTitle} &nbsp;
							<span className={classes.clientsCount}>
								({tableData?.length})
							</span>
						</h1>
						<div className={classes.buttons}>
							<Button
								className={classes.button}
								onClick={onExportSelectedId}
							>
								<ExportIcon />
								{strings?.exportDataButton}
							</Button>
						</div>
					</div>
					<div className={classes.inputs}>
						<DefaultInput
							label={strings?.searchLabel}
							className={classes.input}
							placeholder={strings?.searchPlaceholder}
							prefix={<SearchIcon />}
							value={code}
							onChange={(e) => {
								setCurrentPage(1);
								setCode(e.target.value);
							}}
							allowClear
						/>
					</div>
					<div className={classes.pagination}>
						<PaginationTable
							current={currentPage}
							pageSize={pageSize}
							total={totalItems}
							startOrderIndex={startOrderIndex}
							endOrderIndex={endOrderIndex}
							onChange={handlePageChange}
							onShowSizeChange={handlePageSizeChange}
						/>
					</div>
					<div
						className="ag-theme-alpine"
						style={{
							height: 600,
							width: "100%",
						}}
					>
						<AgGridReact
							rowData={filteredData}
							columnDefs={tableColumns}
							defaultColDef={defaultColDef}
							undoRedoCellEditing={true}
							undoRedoCellEditingLimit={20}
							suppressCopyRowsToClipboard={true}
							defaultExcelExportParams={
								defaultExcelExportSettings
							}
							ref={grid}
							enableRangeSelection={true}
							cacheQuickFilter={true}
							onFirstDataRendered={onFirstDataRendered}
							onRowDoubleClicked={openEditModal}
						/>
					</div>
				</div>
			</div>
			<Modal
				open={openModal}
				onCancel={cleanStateOnClose}
				title={strings?.userDetailsTitle}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1050}
				maskStyle={{
					display: "flex",
					flexWrap: "wrap",
					height: 500,
					padding: 0,
				}}
				bodyStyle={{
					height: 500,
					overflowY: "auto",
					paddingLeft: 10,
					paddingRight: 0,
				}}
				footer={() => (
					<div className="flex flex-row justify-end">
						<Button
							type="default"
							size="large"
							onClick={() => setOpenModal(false)}
						>
							{strings?.cancelButton}
						</Button>
						<Button
							type="primary"
							size="large"
							// className="bg-blue-600"
							style={{ backgroundColor: "#4F16C2" }}
							onClick={saveUnconfirmedUserDetails}
						>
							{strings?.saveButton}
						</Button>
					</div>
				)}
			>
				<Divider />
				<div className="flex flex-col gap-6">
					<div className="flex flex-row gap-5 flex-wrap">
						<DefaultInput
							className="registerInput"
							label={strings?.firstNameLabel}
							placeholder={strings?.firstNamePlaceholder}
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
						/>
						<DefaultInput
							className="registerInput"
							label={strings?.lastNameLabel}
							placeholder={strings?.lastNamePlaceholder}
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
						/>
						<DefaultPhoneInput
							className="registerInput"
							label={strings?.phoneLabel}
							placeholder={strings?.phonePlaceholder}
							initialPhoneNumber={phone}
							onPhoneNumberChange={(e) => setPhone(e)}
						/>
					</div>
					<div className="flex flex-row gap-5 flex-wrap">
						<DefaultInput
							className="registerInput"
							label={strings?.idNumberLabel}
							value={identificationNumber}
							onChange={(e) =>
								setIdentificationNumber(e.target.value)
							}
							placeholder={strings?.idNumberPlaceholder}
						/>
						<DefaultInput
							className="registerInput"
							label={strings?.emailLabel}
							placeholder={strings?.emailPlaceholder}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
						<DefaultSelect
							className="registerInput"
							label={strings?.countryLabel}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.countryPlaceholder}
							options={countryDropDown}
							value={country}
							onChange={onCountrySelect}
						/>
					</div>
					<div className="flex flex-row gap-5 flex-wrap">
						<DefaultSelect
							className="registerInput"
							label={strings?.cityLabel}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.cityPlaceholder}
							options={cityDropDown}
							value={city}
							onChange={onCitySelect}
							labelInValue
						/>
						<DefaultInput
							className="registerInput"
							label={strings?.addressLabel}
							placeholder={strings?.addressPlaceholder}
							value={address}
							onChange={(e) => setAddress(e.target.value)}
						/>
						<DefaultInput
							className="registerInput"
							label={strings?.usernameLabel}
							placeholder={strings?.usernamePlaceholder}
							value={username}
							onChange={(e) => setUsername(e.target.value)}
						/>
					</div>
					{userRoleId === userRoles.CLIENT && (
						<>
							<div className="flex flex-row gap-5 flex-wrap">
								<DefaultInput
									className="registerInput"
									label={strings?.businessNameLabel}
									placeholder={
										strings?.businessNamePlaceholder
									}
									value={businessName}
									onChange={(e) =>
										setBusinessName(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.businessNameLabel}
									placeholder={
										strings?.businessNamePlaceholder
									}
									value={businessNumber}
									onChange={(e) =>
										setBusinessNumber(e.target.value)
									}
								/>
								<DefaultPhoneInput
									className="registerInput"
									label={strings?.businessPhoneNumberLabel}
									placeholder={
										strings?.businessNumberPlaceholder
									}
									initialPhoneNumber={businessPhoneNumber}
									onPhoneNumberChange={(e) =>
										setBusinessPhoneNumber(e)
									}
								/>
							</div>
						</>
					)}
					<div className="flex flex-col gap-2 items-start">
						<p>{strings?.postalServicePaymentLabel}</p>
						<div className="flex flex-row justify-around gap-2">
							<DefaultSwitch
								label={strings?.cashLabel}
								checked={cash}
								onChange={changeSwitch}
							/>
							<DefaultSwitch
								label={strings?.bankLabel}
								checked={bank}
								onChange={changeSwitch}
							/>
						</div>
					</div>
					{/* <Image.PreviewGroup items={imageUrls}> */}
					{imageUrls?.map((imageUrl, index) => (
						<Image key={index} width={200} src={imageUrl} />
					))}
					{/* </Image.PreviewGroup> */}
					{/* <ImagePreviewGroup imageUrls={imageUrls} /> */}
				</div>
			</Modal>
			<Modal
				open={openConfirmModal}
				onCancel={() => setOpenConfirmModal(false)}
				onOk={onAccept}
				title={strings?.confirmAcceptanceTitle}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<p>
					{`${strings?.confirmAcceptanceText} `}
					<strong>{firstName}</strong> <strong>{lastName}</strong>
				</p>
			</Modal>
			<Modal
				open={openRejectModal}
				onCancel={() => setOpenRejectModal(false)}
				onOk={onDelete}
				title={strings?.confirmRejectionTitle}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<p>
					{`${strings?.confirmRejectionText} `}
					<strong>{firstName}</strong> <strong>{lastName}</strong>.
				</p>
			</Modal>
		</>
	);
};

export default UnapprovedAccounts;
